import { Component, AfterViewInit, ComponentFactoryResolver, ChangeDetectorRef, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { AppService } from '@api';
import { RespuestaEstatusEnum } from '@enumeraciones/Enumeraciones.enum';
import { AlertaEnum } from '@mensaje/Enumeraciones/MensajeEnumeraciones.enum';
import { MensajeService } from '@mensaje/Mensaje.Service';
import { TranslateService } from '@ngx-translate/core';
import { SistemaService } from '@servicios/Sistema.Service';



@Component({
    selector: 'reporteevaluaciondetalle_tallerpadre',
    templateUrl: './evaluaciondetalle_tallerpadre.component.html',
    styleUrls: ['./evaluaciondetalle_alumno.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class ReporteEvaluacionDetalleTallerPadreComponent implements AfterViewInit{
    consulta!:boolean;
    @Input() general!: any;
    @Input() periodo!: any;
    @Input() listapuesto!: any;
    buscarcompetencia: boolean = false;
    buscarcriterio: boolean = false;

    grupo:any;
    taller:any;
    visual: number = 0;

    listageneral:any[];
    listataller: any[];
    listagrupos: any[];
    listaobservacion: any[] = [];
    puesto:number = 0;
    puestolocal: number = 0;

    constructor(private cdr: ChangeDetectorRef,private appService: AppService, private mensajeService: MensajeService, public sistemaService: SistemaService, public translate: TranslateService, public _cfr: ComponentFactoryResolver){
        this.listageneral = [];
        this.listataller = [];
        this.listagrupos = [];
    }

    ngAfterViewInit(){

        this.visual = 1;
        //this.materiaygrupo();
        if(this.general.otropuesto){
          //this.buscarpuesto();
        }else{
          this.puestolocal = this.general.puestoid;
          this.getmateria();
        }
    }

    getgrupo(taller:any){
      if(taller.length > 0){
        let datos = {};
        if(taller[0] == 0){
          datos = {"entidad":this.general, "periodo":this.periodo};
        }else{
          datos = {"entidad":this.general, "periodo":this.periodo, "taller":taller}
        }
        this.appService.Post("reporte/evaluacion/grupopadretaller",datos).then(res=>{
          if(res.status == RespuestaEstatusEnum.Success){
              this.listagrupos = res.data;
          }
        })
      }else{
        this.listagrupos = [];
      }

    }

    getmateria(){
      this.appService.Post("reporte/evaluacion/materiapadretaller",{"entidad":this.general, "periodo":this.periodo}).then(res=>{
        if(res.status == RespuestaEstatusEnum.Success){
            this.listataller = res.data;
            if(this.listataller.length == 0){
              this.getgrupo([0]);
            }
        }
      })
    }
    consultar(){
      if(this.general.otropuesto){
        if(this.puesto){
          this.CargarInfo(this.visual);
        }else{
          this.mensajeService.Alerta(AlertaEnum.Warning, "No se tienen seleccionado ningun puesto para visualizar resultados");
        }
      }else{
        this.CargarInfo(this.visual);
      }
    }

    VerPorCompetencia(event:any){
        this.listageneral = [];
        if(event){
          this.buscarcriterio = false;
          if(this.general.otropuesto){
            if(this.puesto){
              this.visual = 3;
              this.CargarInfo(this.visual);
            }else{
              this.mensajeService.Alerta(AlertaEnum.Warning, "No se tienen seleccionado ningun puesto para visualizar resultados");
            }
          }else{
            this.buscarcriterio = false;
            this.visual = 3;
            this.CargarInfo(this.visual);
          }
        }else{
          if(this.general.otropuesto){
            if(this.puesto){
              this.visual = 1;
              this.CargarInfo(this.visual);
            }else{
              this.mensajeService.Alerta(AlertaEnum.Warning, "No se tienen seleccionado ningun puesto para visualizar resultados");
            }
          }else{
            this.visual = 1;
            this.CargarInfo(this.visual);
          }
        }
        this.cdr.detectChanges();
    }

    VerPorCriterio(event:any){
        this.listageneral = [];
        if(event){
          this.buscarcompetencia = false;
          if(this.general.otropuesto){
            if(this.puesto){
              this.visual = 2;
              this.CargarInfo(this.visual);
            }else{
              this.mensajeService.Alerta(AlertaEnum.Warning, "No se tienen seleccionado ningun puesto para visualizar resultados");
            }
          }else{
            this.buscarcompetencia = false;
            this.visual = 2;
            this.CargarInfo(this.visual);
          }
        }else{
          if(this.general.otropuesto){
            if(this.puesto){
              this.visual = 1;
              this.CargarInfo(this.visual);
            }else{
              this.mensajeService.Alerta(AlertaEnum.Warning, "No se tienen seleccionado ningun puesto para visualizar resultados");
            }
          }else{
            this.visual = 1;
            this.CargarInfo(this.visual);
          }
        }
        this.cdr.detectChanges();
    }

    CargarInfo(tipovisualizar: number){
      let info = {"general":this.general, "periodo": this.periodo, "agrupar":tipovisualizar, "tipoJoin": 2, "grupo":this.grupo, "puestolocal": this.puesto, "taller":this.taller};
        this.appService.Post("reporte/evaluacion/preguntapadretaller",info).then(res=>{
            if(res.status == RespuestaEstatusEnum.Success){
                this.listageneral = res.data.datos;
                this.listaobservacion = res.data.observaciones;
                if(this.listageneral.length == 0 ){
                    this.mensajeService.Alerta(AlertaEnum.Warning, "No se encontró evaluaciones de padres de familia")
                }else{
                    this.listageneral.map((competencia: any) => {
                        competencia.colortext = this.cambiarcolor(competencia.color);
                    })
                }
                this.cdr.detectChanges();
            }
        })
    }

    cambiarcolor(color: any): string {
        let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color);
        let val: any = [];
        if (result) {
            let r = parseInt(result[1], 16)
            let g = parseInt(result[2], 16)
            let b = parseInt(result[3], 16)
            val = this.rgbToHsl(r, g, b);
        }
        if (val[2] < 50) {
            return "colorblanco"
        } else {

            return "colornegro";
        }
    }

    rgbToHsl(r: any, g: any, b: any) {
        r /= 255;
        g /= 255;
        b /= 255;

        // Find greatest and smallest channel values
        let cmin = Math.min(r, g, b),
            cmax = Math.max(r, g, b),
            delta = cmax - cmin,
            h = 0,
            s = 0,
            l = 0;

        // Calculate hue
        // No difference
        if (delta == 0)
            h = 0;
        // Red is max
        else if (cmax == r)
            h = ((g - b) / delta) % 6;
        // Green is max
        else if (cmax == g)
            h = (b - r) / delta + 2;
        // Blue is max
        else
            h = (r - g) / delta + 4;

        h = Math.round(h * 60);

        // Make negative hues positive behind 360°
        if (h < 0)
            h += 360;

        // Calculate lightness
        l = (cmax + cmin) / 2;

        // Calculate saturation
        s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));

        // Multiply l and s by 100
        s = +(s * 100).toFixed(1);
        l = +(l * 100).toFixed(1);

        return [h, s, l];
    }

    buscarpuesto(){
      return new Promise((resolve : any) =>{
      this.appService.Post("reporte/evaluacion/obtenerpuesto",{"data":this.general, "periodoevaluacionid":this.periodo.periodoevaluacionid}).then(res=>{
        if(res.status == RespuestaEstatusEnum.Success){
          this.listapuesto = res.data;
          return resolve(true);
        }else{
          return resolve(false);
        }
      })
      })

    }

    buscardatos(data:any){

      if(data){
        this.general.puestoid = data;
        this.puestolocal = data;
        this.getmateria();
      }else{
        this.listageneral = [];
        this.listaobservacion = [];
        this.listataller = [];
        this.listagrupos = [];
      }
    }
}
